<template>
  <div class='cont'>
    <el-dropdown :split-button="true" type="primary" @click="handleClick" @command="handleCommand">
      {{btnName}}
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="data.title" v-for='data in dropData'>{{data.title}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<style scope>
.cont {
  display: inline-block;
  vertical-align: middle;
  /*margin-left: 20px;*/
}
</style>
<script>
  /**
   * @author duoremix
   * @param Number ContentId 功能集Id
   * @param Number dealId 功能点id
   * @param Object query 跳转带来的参数
   */
  import http from '../../../assets/js/http'
  import cmsConfig from '../../../config/cmsConfig'
  import dealMethod from './mixins/dealMethod'  // 执行各操作的方法集合
  import dealCallback from './mixins/dealCallback'  // 执行各操作的回调集合
  export default {
    name: 'dropdownRender',
    props: {
      btnName: {
        type: String,
        default() {
          return ''
        }
      },
      dropData: {
        type: Array,
        default() {
          return []
        }
      },
      deal: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
      }
    },
    methods: {
      handleClick() {
        this.$emit('dropdownEvent', { deal: this.deal, title: this.btnName })
      },
      handleCommand(val) {
        this.$emit('dropdownEvent', { deal: this.deal, title: val })
      }
    },
    created() {
    },
    components: {
    },
    mixins: [http, cmsConfig, dealMethod, dealCallback]
  }
</script>


// WEBPACK FOOTER //
// dropdownRender.vue?4ec61790